module.exports = __webpack_public_path__ + "static/media/support_logo.14d11b79.png";